import { useNavigate } from "react-router-dom";
import "./KitMain.css";
import PageHeading from "../../PageHeading/PageHeading";
import ItemForm from "../../ItemForm/ItemForm";
import ConstructorBlock from "../ConstructorBlock/ConstructorBlock";
import {
  PLATFORM_MAIN_LINK,
  SETTINGS_INFO_LINK,
  SETTINGS_MAIN_LINK,
} from "../../../../assets/utils/constants";

function KitMain() {
  const navigate = useNavigate();

  return (
    <div className="kit-main">
      <PageHeading
        className={"kit-main__heading"}
        title={"Главная страница"}
        actions={[]}
      />
      <ItemForm containerClassName={"kit-main__container"}>
        <form className="kit-main__form">
          <ConstructorBlock>
            <p className="kit-main__moved-text">
              Изменение логотипа и иконки перенесено в новое место:{" "}
              <button
                className="kit-main__moved-link"
                type="button"
                onClick={() => {
                  navigate(
                    `${PLATFORM_MAIN_LINK}/${SETTINGS_MAIN_LINK}/${SETTINGS_INFO_LINK}?openBranding=1`
                  );
                }}
              >
                Настройки магазина
              </button>
              .
            </p>
          </ConstructorBlock>
        </form>
      </ItemForm>
    </div>
  );
}

export default KitMain;
